/**
 * 通用全局方法，放置在window.Jackery.Utils对象里可直接调用，方便内嵌JS的快速开发
 * 示例：window.Jackery.Utils.isElementInViewport($el)
 */

/**
 * 检测元素是否进入视窗
 * @param $el - 元素节点
 * @param {number} threshold - 距离进入可视范围指定距离时候触发
 * @returns {boolean}
 */
function isElementInViewport($el, threshold = 0) {
  let rect;
  if ($el.length > 1) {
    rect = $el[0].getBoundingClientRect();
  } else {
    rect = $el.getBoundingClientRect();
  }
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  return (
    rect.bottom >= 0 && rect.right >= 0 && rect.top <= (windowHeight + threshold) && rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
/**
 * 检测元素是否移出视窗
 * @param $el 元素
 * @returns {boolean}
 */
function isElementOutOfViewport($el) {
  let rect;
  if ($el.length > 1) {
    rect = $el[0].getBoundingClientRect();
  } else {
    rect = $el.getBoundingClientRect();
  }
  const isAboveViewport = rect.bottom < 0;
  const isBelowViewport = rect.top > (window.innerHeight || document.documentElement.clientHeight);
  const isLeftOfViewport = rect.right < 0;
  const isRightOfViewport = rect.left > (window.innerWidth || document.documentElement.clientWidth);
  return isAboveViewport || isBelowViewport || isLeftOfViewport || isRightOfViewport;
}

export {
  isElementInViewport,
  isElementOutOfViewport
}
